/* eslint-disable no-unused-vars */
import { axiosPublic, axiosPrivate, getSequencer } from ".";

export const uploadComboImg = (params, config) =>
  axiosPrivate.post("combo/upload/imagem", params, {
    ...config,
    onUploadProgress: progressEvent => {
      if (config.onUploadProgress) {
        config.onUploadProgress(progressEvent);
      }
    },
  });

export const getComboProducts = params =>
  axiosPrivate.post(
    "combo/produto/listar",
    {
      sequenciador: getSequencer(),
      params,
    },
    {
      cache: false,
    }
  );

export const getCombo = params =>
  axiosPrivate.post(
    "combo/listar",
    {
      sequenciador: params?.marketplace ? "" : getSequencer().toString(),
      ...params,
    },
    {
      cache: false,
    }
  );

export const registerCombo = params =>
  axiosPrivate.post("combo/cadastro", {
    ...params,
  });
export const updateCombo = (params, idcombo) =>
  axiosPrivate.put(`combo/alterar/${idcombo}`, {
    ...params,
  });

export const deleteCombo = idcombo =>
  axiosPrivate.delete(`combo/deletar/${idcombo}`);

export const getComboById = idcombo =>
  axiosPrivate.post(`combo/detalhe/${idcombo}`);
